import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { CriarEntradaDeNotasFormData } from "../schema/criar-entrada-de-notas.schema";

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/service-invoice/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const findAll = async (query: string, pagina = 0, limite = 10) => {
    try {
        const response = await baseApiService.get(`/service-invoice?page=${pagina + 1}&limit=${limite}&${query}`);
        return response.data.data;
    } catch (error) {
        throw errosHandler(error);
    }
};

const adicionar = async (data: CriarEntradaDeNotasFormData): Promise<void> => {
    try {
        await baseApiService.post('/service-invoice', data);
    } catch (err) {
        throw errosHandler(err);
    }
};

const editar = async (id: string, data: CriarEntradaDeNotasFormData): Promise<void> => {
    try {
        await baseApiService.put(`/service-invoice/${id}`, data);
    } catch (err) {
        throw errosHandler(err);
    }
};



export const entradaDeNotasService = {
    findAll,
    adicionar,
    detalhar,
    editar
};

